import React from 'react'
import styled from 'styled-components'

const WorkInfo = styled.div`
    position: relative;
    // margin-bottom 70px minus project box margin
    margin-bottom: calc(4.375rem - 1.5rem);
    .work-info-cols {
        display: grid;
        column-gap: 2rem;
        grid-template-columns: [spacer] 1fr [project-info] 2fr [spacer] 1fr [process-1] 4fr [process-2] 3fr [spacer] 1fr;
    }
    .project-info {
       grid-area: project-info;
    }
    .project-process-1 {
        grid-area: process-1;
    }
    .project-process-2 {
        grid-area: process-2;
    }
    .project-box {
        margin-bottom: 1.5rem;
        p {
            margin-top: 0;
        }
    }
    button {
        background: transparent;
        border: none;
        padding: 0;
        margin: 0;
        cursor: pointer;
        display: inline-block;
        vertical-align: middle;
        font-size: 0.8rem;
        font-family: "Ogg-Roman", serif;
    }
    .plus {
        font-size: 1.333rem;
        margin-right: 0.2rem;
    }
    span.info-title-line {
        display: inline-block;
        vertical-align: middle;
        margin-right: 1rem;
        height: 1px;
        width: 5.5rem;
        background: black;
    }
    p.project-info-title {
        display: inline-block;
    }
    .project-info-year {
        font-family: "Ogg-Roman", serif;
    }
    @media all and (max-width: 767px) {
        .work-info-cols {
            display: block;
            padding-left: 2rem;
            padding-right: 2rem;
        }
        .project-process-1 {
            margin-top: 2.5rem;
        }
    }
`

const CaseStudyInfo = ({
    approach,
    challenge,
    solution,
    projectSubtitle,
    brandName
}) => {
    
    return (
        <WorkInfo>
           
                <div className="work-info-cols">

                    { /* column 1 */ }

                    <div className="project-info">
                        <h2>{brandName}</h2>                      
                        <span className="sans-lg">{projectSubtitle}</span>                      
                    </div>

                     { /* column 2 */ }

                    <div className="project-process-1">
                        <div className="project-box project-process">
                            <h2>Approach</h2>
                            <div dangerouslySetInnerHTML={{__html: approach}} />
                        </div>                          
                        <div className="project-box project-process">
                            <h2>Challenge</h2>
                            <div dangerouslySetInnerHTML={{__html: challenge}} />
                        </div>
                                            
                    </div>

                    { /* column 3 */ }

                    <div className="project-process-2">
                        <div className="project-box project-process">
                            <h2>Solution</h2>
                            <div dangerouslySetInnerHTML={{__html: solution}} />
                        </div>  
                    </div>

                </div>
          
        </WorkInfo>
    )
}

export default CaseStudyInfo
